

import React, { useEffect } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;
  height: auto;
  padding-top: 10vh;
  border-bottom: 18vh solid var(--primary);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 10vw;

  @media (max-width: 1050px){
      gap: 12vw;
      border-bottom: 8vh solid var(--primary);
  }

  @media (max-width: 576px){
      border-bottom: 8vh solid var(--primary);
      gap: 8vw;
  }
`;

const LeftDiv = styled.div`
  width: 30vw;
  height: 80vh;
  display: flex;
  align-items: baseline;
  justify-content: center;
  position: relative;

  @media(max-width:1050px){
      height: 50vh;
  }
`;

const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;

  @media(max-width:1050px){
    width: 24vw;
    height: 56vh;
  }
`;

const RightDiv = styled.div`
  width: 20vw;
  height: 80vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 4vh;

  @media (max-width:1050px){
      height: 50vh;
      width: 30vw;
  }
  @media (max-width:768px){
      width: 35vw;
  }
  @media (max-width:576px){
      width: 40vw;
      height: 50vh;
  }
  @media (max-width:400px){
      width: 46vw;
      height: 50vh;
  }
`;

const RectLabelTop = styled.div`
  width: fit-content;
  height: fit-content;
  font-size: 20px;
  padding: 2vh 1vw;
  border-radius: 10px;
  color: #ffffff;
  font-weight: 400;
  background-color: var(--secondary);
  opacity: 0;

  @media(max-width:1200px){
      font-size: 16px;
  }

  @media(max-width:576px){
      font-size: 14px;
      padding: 1vh 1vw;
  }
`;

const RectLabelBot = styled(RectLabelTop)`
  /* Bottom labels inherit from top, same styles */
`;

const LabelItl = () => {

  const handleScroll = () => {
    const parent = document.getElementById('itl-label-div');
    const itlImg = document.getElementById('itl-img');
    const itlLabelsTop = [...document.querySelectorAll('.itl-labels-top')];
    const itlLabelsBottom = [...document.querySelectorAll('.itl-labels-bottom')];

    const parentTop = parent.offsetTop;

    if(window.scrollY >= parentTop - 50){
      itlImg?.classList.add('move-down-brkr');

      itlLabelsTop.forEach(sl => sl.classList.add('move-down-label'));
      itlLabelsBottom.forEach(sl => sl.classList.add('move-up-label'));
    } else {
      itlImg?.classList.remove('move-down-brkr');

      itlLabelsTop.forEach(sl => sl.classList.remove('move-down-label'));
      itlLabelsBottom.forEach(sl => sl.classList.remove('move-up-label'));
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <Wrapper id='itl-label-div'>
      <LeftDiv>
        <Img src='/images/itl.png' alt='itl-breaker' id="itl-img"/>
      </LeftDiv>
      <RightDiv>
        <RectLabelTop className='itl-labels-top'>High Productivity</RectLabelTop>
        <RectLabelTop className='itl-labels-top'>Low Noise</RectLabelTop>
        <RectLabelTop className='itl-labels-top'>Long Durability</RectLabelTop>
        <RectLabelBot className='itl-labels-bottom'>Wide Application Range</RectLabelBot>
        <RectLabelBot className='itl-labels-bottom'>High Efficient Design</RectLabelBot>
      </RightDiv>
    </Wrapper>
  );
};

export default LabelItl;